<template>
  <div
    class="poster"
    ref="poster"
    :style="genBgStyle()"
    v-loading="posterVisibility"
    v-on="$listeners"
  >
    <div
      class="mainText"
      :id="'block-0'"
      :style="genTextBoxStyle()"
    >
      <h5
        v-for="item in mainText.editOptions"
        :key="item.name"
        :class="item.enName"
        :style="genTextStyle(item)"
      >
        {{ item.text || '请输入' + item.name }}
      </h5>
    </div>
    <div
      class="portrait-info"
      v-if="portraitInfo.teacherName"
      :style="getStyleFromlabelStyleMap(portraitInfo.labelStyle)"
    >
      <span>{{ portraitInfo.teacherName }}</span>
    </div>
    <div
      class="left_element"
      :style="genElementStyle('Left')"
      v-if="elConfig.remainPart === 1 || elConfig.remainPart === 0"
    >
      <img
        :src="materialUrl(elementImg)"
        :style="{ height: `${elConfig.elementHeight}px` }"
        alt="poster左侧元素"
      />
    </div>
    <div
      class="right_element"
      :style="genElementStyle('Right')"
      v-if="elConfig.remainPart === 2 || elConfig.remainPart === 0"
    >
      <img
        ref="RImg"
        :src="materialUrl(elementImg)"
        :style="{
          height: `${elConfig.elementHeight}px`,
          width: `${elConfig.elementHeight * 4}px`,
        }"
        alt="poster右侧元素"
      />
    </div>
    <img
      v-if="logo && logo.filePath"
      :src="logo.filePath"
      class="logo"
    />
    <div class="blocks">
      <div
        v-for="(block, index) in (posterTextMaps || []).filter(
          (item) => item && item.blockName != 'mainText'
        )"
        :key="index"
        :id="'block-' + (index + 1)"
        :class="['block', block.blockName]"
        :style="block.blockName != 'qrCode' ? blockStyle.bottomStyle : {}"
      >
        <div
          v-for="name in Object.keys(block.editOptions || {})"
          :key="name"
          :class="name"
          :style="genItemStyle(block.blockName, name)"
        >
          <template v-if="name === 'floorName'">
            <span
              v-if="block.editOptions.floorName.text"
              class="txt"
              >{{ block.editOptions.floorName.text }}</span
            >
            <span
              v-else
              class="tips"
              >请输入{{ block.editOptions.floorName.name }}</span
            >
          </template>
          <!-- 含有普通子项 -->
          <template v-else-if="name === 'blockContent'">
            <div
              v-for="child in Object.values(block.editOptions.blockContent)"
              :key="child.enName"
              :class="child.enName"
              :style="genItemStyle(block.blockName, child.enName)"
            >
              <!-- 图片 -->
              <template v-if="child.src != undefined">
                <img
                  v-if="child.src"
                  :src="child.src"
                />
                <span
                  v-else-if="child.enName === 'characterImg'"
                  class="none-img"
                  ><img src="./../icon/none-img.png"
                /></span>
                <i
                  v-else-if="child.enName === 'qrImg'"
                  class="tips"
                  >二维码</i
                >
              </template>
              <!-- 文字属性 -->
              <template v-else>
                <template v-if="child.text">
                  <span
                    v-html="child.text"
                    v-if="block.blockName === 'richText'"
                  ></span>
                  <span v-else>{{ child.text }} </span>
                </template>
                <span
                  v-else
                  class="tips"
                  >请输入{{ child.name }}</span
                >
              </template>
            </div>
          </template>
          <!-- 含有列表类子项 -->
          <template v-else-if="name === 'items'">
            <div
              v-for="(child, childIndex) in block.editOptions.items"
              :key="childIndex"
              :class="['item']"
            >
              <!-- 子项里的属性 -->
              <span
                v-for="(name, index) in Object.keys(child)"
                :key="name + index"
                :class="[name]"
              >
                <!-- 子项里的图片属性 -->
                <template v-if="name === 'img'">
                  <img
                    v-if="child[name].src"
                    :src="child[name].src"
                  />
                  <img
                    v-else
                    class="none-img"
                    src="./../icon/none-img.png"
                  />
                </template>
                <!-- 子项里的文字属性 ，第一个子项有icon，其他子项都需显示-->
                <template v-else>
                  <span
                    v-if="block.editOptions.items[0][name].showLabelStyle"
                    class="icon"
                    :style="genIconStyle(block.editOptions.items[0][name])"
                  >
                    <img
                      :style="genIconStyle(block.editOptions.items[0][name])"
                      :src="genIconStyle(block.editOptions.items[0][name]).src"
                    />
                    <i
                      class="num"
                      v-if="
                        genIconStyle(block.editOptions.items[0][name]).hasNumber
                      "
                      >{{ childIndex + 1 }}</i
                    ></span
                  >{{ child[name].text
                  }}<span
                    v-if="!child[name].text"
                    class="tips"
                    >请输入{{ child[name].name + (childIndex + 1) }}</span
                  >
                </template>
              </span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <img
      class="slogan"
      v-if="logo && logo.sloganPath"
      :src="logo.sloganPath"
    />
  </div>
</template>

<script>
import { getLabelStyleMenu, hexToRgba, materialUrl } from "@/assets/scripts/common.js";
import { iconStyleMap } from "@/pages/poster/js/poster-static";
export default {
  name: "poster-long",
  props: {
    size: {
      required: false,
      type: Object,
      default: () => ({
        width: 375,
        height: 667,
      }),
    },
    bgConfig: {
      required: true,
      type: Object,
    },
    elementImg: {
      required: true,
      type: String,
    },
    textInfo: {
      required: true,
      type: Object,
    },
    elConfig: {
      required: false,
      type: Object,
      default: () => ({
        elementWidth: 480,
        elementHeight: 240,
        offsetX: 0,
        remainPart: 0,
      }),
    },
    portraitInfo: {
      type: Object,
      default: () => ({}),
    },
    // 海报文字模块
    posterTextMaps: {
      type: Array,
      required: true,
    },
    contentStyle: {
      type: Object,
      required: true,
      default: () => ({
        bottomBg: "",
        filePath: "",
        repeatBg: "",
      }),
    },
    logo: {
      type: Object,
      default: () => ({
        filePath: "",
        id: 0,
        logoName: "",
      }),
    },
  },
  data() {
    return {
      posterVisibility: false,
    };
  },
  computed: {
    // 主文字
    mainText() {
      return (
        (this.posterTextMaps || []).find(
          item => item && item.blockName === "mainText"
        ) || {
          blockName: "mainText",
          editOptions: {},
        }
      );
    },
    posterImg() {
      return {
        bgConfig: this.bgConfig,
        elementImg: this.elementImg,
      };
    },
    themeColor() {
      const { tagBgColor } = this.bgConfig;
      let themeColor = tagBgColor || "#D6DBE0";
      themeColor = themeColor.includes(",")
        ? themeColor
        : `${themeColor}, ${themeColor}`;
      return themeColor;
    },
    // 模块的样式
    blockStyle() {
      const contentStyle = this.contentStyle;
      const headerStyle = {
        background: `url(${contentStyle?.filePath}) no-repeat center 0 / 100% auto`,
      };
      const bottomStyle = {
        background: `url(${contentStyle?.bottomBg}) no-repeat 0 bottom / 100% auto`,
      };
      const repeatStyle = {
        background: `url(${contentStyle?.repeatBg}) repeat-y 0 0 / 100% auto`,
      };
      return {
        headerStyle,
        repeatStyle,
        bottomStyle,
      };
    },
  },
  watch: {
    posterImg: {
      handler(newImg) {
        this.posterVisibility = true;
        this.imgLoading(newImg);
      },
    },
  },
  methods: {
    materialUrl,
    imgLoading(newImg) {
      Promise.all([
        this.getImg(newImg.bgConfig && newImg.bgConfig.src),
        this.getImg(newImg.elementImg),
      ]).then(() => {
        this.posterVisibility = false;
        this.$emit("loaded");
      });
    },
    getImg(imgUrl) {
      return new Promise(resolve => {
        if (!imgUrl) {
          resolve(true);
          return;
        }
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = materialUrl(imgUrl);
      });
    },
    genBgStyle() {
      const colorArr = this.themeColor.split(",");
      return {
        width: `${this.size.width}px`,
        // height: `auto`,
        backgroundImage: `linear-gradient(to bottom, ${hexToRgba(colorArr[0], 0.13)} 400px, ${colorArr[0]} 500px, ${colorArr[1]} 100%), url('${materialUrl(this.bgConfig.src)}')`,
        // backgroundImage: `linear-gradient(to bottom, transparent 13%, ${this.themeColor} 100%), url('//bar.xkw.com${this.bgConfig.src}')`,
      };
    },
    genElementStyle(type) {
      let styleObj = {
        width: `${this.elConfig.elementWidth}px`,
        height: `${this.elConfig.elementHeight}px`,
      };
      styleObj[`margin${type}`] = `${-this.elConfig.offsetX}px`;
      styleObj.marginBottom = `${this.elConfig.offsetY}px`;
      styleObj.marginLeft = "auto";
      return styleObj;
    },
    genTextBoxStyle() {
      const { textPositionX, textPositionY, textAlignType } = this.textInfo;
      return {
        marginTop: textPositionY + "px",
        marginLeft: textPositionX + "px",
        marginRight: textPositionX + "px",
        textAlign: textAlignType + "" === "0" ? "center" : "left",
        textShadow: "0px 4px 10px rgba(48, 48, 48, 0.30)",
      };
    },
    genTextStyle(textItem) {
      let styleObj = {
        color: textItem.fontColor,
        marginTop: textItem.marginTop + "px",
        fontSize: textItem.fontSize + "px",
        fontFamily: textItem.fontFamily,
        lineHeight: textItem.lineHeight + "px",
      };
      const labelStyle = this.getStyleFromlabelStyleMap(textItem.labelStyle);
      if (textItem.labelStyle && textItem.showLabelStyle) {
        Object.assign(styleObj, {
          display: "inline-block",
          lineHeight: "1.3em",
          padding: "0 0.5em .1em",
          textShadow: "none",
          ...labelStyle,
        });
      }
      return styleObj;
    },
    // 根据labelStyleId获取样式
    getStyleFromlabelStyleMap(labelStyleId) {
      if (!labelStyleId) return {};
      const { tagBgColor } = this.bgConfig;
      const labelStyleMap = getLabelStyleMenu(tagBgColor || "");
      return labelStyleMap[labelStyleId]?.style || {};
    },
    // 生成属性的样式
    genItemStyle(blockName, itemName) {
      if (blockName != "qrCode" && itemName === "floorName") {
        return this.blockStyle.headerStyle;
      }
      if (itemName === "characterName") {
        return this.genGradientBg();
      }
      if (itemName === "items") {
        return this.blockStyle.repeatStyle;
      }
      if (blockName != "qrCode" && itemName === "blockContent") {
        return this.blockStyle.repeatStyle;
      }
      return {};
    },
    // 生成渐变背景
    genGradientBg() {
      return {
        background: `linear-gradient(90deg, ${this.themeColor} 100%)`,
      };
    },
    // 内容区的小icon样式
    genIconStyle(styleMap) {
      if (!styleMap.labelStyle || !styleMap.showLabelStyle) return {};
      return iconStyleMap[styleMap.labelStyle]?.style || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.poster {
  position: relative;
  // padding: 1px 0 1px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center 0;
  z-index: 10;
  .left_element,
  .right_element {
    position: relative;
    height: 100%;
    margin-top: -20px;
    overflow: hidden;
    z-index: 10;
    img {
      position: absolute;
      height: auto;
      max-width: none;
      bottom: 0;
    }
  }
  .left_element {
    img {
      left: 0;
    }
  }
  .right_element {
    img {
      right: -20px;
    }
  }
  .portrait-info {
    position: absolute;
    top: 183px;
    right: 37px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    padding: 11px 8px;
    color: #fff;
    font-size: 14px;
    white-space: break-spaces;
    text-align: center;
    line-height: 16px;
    z-index: 11;
    span {
      display: block;
    }
  }
  .logo {
    position: absolute;
    top: 0;
    left: 0;
    height: 36px;
  }
  .slogan {
    display: block;
    width: 100%;
    border-radius: 20px 20px 0 0;
  }
  .mainText {
    z-index: 11;
    .subtitle {
      line-height: 1.3rem;
    }
    .title {
      height: 74px;
      word-break: break-all;
    }
  }

  .blocks {
    position: relative;
    z-index: 11;
    width: 335px;
    margin: 0 auto;
    color: #fff;
    .block {
      position: relative;
      display: block;
      padding: 60px 0 26px;
      margin-bottom: 18px;
      .floorName {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        height: 60px;
        line-height: 46px;
        font-size: 19px;
        font-weight: 700;
        text-align: center;
        color: #fff;
        font-family: '阿里巴巴普惠体 REGULAR';
      }
      &.normalImgText {
        .items {
          display: flex;
          margin: -1px auto 0;
          padding: 2px 28px 0;
          flex-wrap: wrap;
          height: calc(100% - 50px);
          flex-direction: column;
          justify-content: center;
          align-content: center;
          gap: 12px;
          .item {
            display: flex;
            align-items: center;
            justify-content: start;
            height: 24px;
            gap: 5px;
            color: #333;
            line-height: 24px;
            font-size: 13px;
            white-space: nowrap;
            .content {
              display: flex;
              align-items: center;
              justify-content: start;
              height: 100%;
              gap: 5px;
              color: #333;
              line-height: 24px;
            }
            .icon {
              position: relative;
              .num {
                position: absolute;
                left: 50%;
                top: 50%;
                color: #fff;
                transform: translate(-50%, -50%);
              }
            }
            .tips {
              color: #999;
            }
          }
        }
      }
      &.characterCard {
        .blockContent {
          margin-top: -1px;
          padding-top: 6px;
        }
        .characterImg {
          position: relative;
          margin: 0 20px 0;
          width: 122px;
          height: 135px;
          border-radius: 6px;
          img {
            position: relative;
            z-index: 2;
            display: block;
            height: 100%;
            width: auto;
            transform: translateX(-364px);
            border-radius: 6px;
          }
          .none-img {
            position: relative;
            z-index: 2;
            display: block;
            height: 100%;
            width: 100%;
            background: #f3f7fd;
            border-radius: 6px;
            img {
              position: absolute;
              width: 35px;
              height: 30px;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
        .characterName {
          position: absolute;
          width: 22px;
          z-index: 5;
          height: auto;
          top: 85px;
          left: 24px;
          line-height: 16px;
          text-align: center;
          border-radius: 16px;
          padding: 8px 0px;
          font-size: 14px;
          font-weight: 700;
          overflow-wrap: break-word;
        }
        .characterTitle {
          position: absolute;
          bottom: 96px;
          left: 134px;
          z-index: 7;
          font-size: 12px;
          font-weight: 700;
          color: #333;
        }
        .characterInfo {
          position: absolute;
          bottom: 26px;
          width: 184px;
          right: 20px;
          height: 100px;
          z-index: 6;
          background-color: #fff8e1;
          border-radius: 10px 10px 10px 0;
          font-size: 12px;
          color: #333;
          word-break: break-all;
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 44px;
            height: 100%;
            background-color: #fff8e1;
            border-radius: 10px 0 0 10px;
            transform: skewX(-18deg) translateX(-20px);
          }
          span {
            position: absolute;
            top: 34px;
            left: 3px;
            width: 170px;
            height: 50px;
            line-height: 18px;
          }
        }
      }
      &.advancedImgText {
        .items {
          margin-top: -1px;
          padding: 6px 20px 0;
          display: flex;
          flex-wrap: wrap;
          height: calc(100% - 50px);
          flex-direction: column;
          justify-content: center;
          align-content: center;
          gap: 24px;
          .item {
            position: relative;
            width: 100%;
            height: 60px;
            padding-left: 72px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            gap: 4px;
          }
          .img {
            position: absolute;
            top: 0;
            left: 0;
            width: 60px;
            height: 60px;
            border-radius: 100%;
            // background: #ececec;
            img {
              display: block;
              border-radius: 100%;
              object-fit: cover;
              width: 60px;
              height: 60px;
            }
            .none-img {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 26px;
              height: 22px;
              border-radius: 0;
            }
          }
          .title {
            width: 100%;
            font-size: 14px;
            font-weight: 700;
            line-height: 16px;
            color: #333;
          }
          .content {
            width: 100%;
            font-size: 12px;
            line-height: 20px;
            color: #333;
            white-space: pre-wrap;
            word-break: break-all;
          }
          .tips {
            color: #999;
          }
        }
      }
      &.richText {
        .blockContent {
          margin-top: -1px;
        }
        .content {
          padding: 6px 20px 0;
          font-size: 14px;
          line-height: 24px;
          color: #333;
          white-space: pre-wrap;
          overflow-wrap: break-word;
          ::v-deep img {
            max-width: 100%;
            height: auto;
            margin: 3px 0;
          }
          .tips {
            color: #999;
          }
        }
      }
      &.qrCode {
        height: 87px;
        .floorName {
          width: 194px;
          position: absolute;
          top: auto;
          bottom: 34px;
          left: 14px;
          color: #fff;
          text-shadow: 0px 4px 10px rgba(48, 48, 48, 0.3);
          font-size: 15px;
          line-height: 21px;
          height: auto;
          text-align: left;
          font-style: normal;
          font-weight: 400;
          white-space: break-spaces;
          word-wrap: break-word;
          font-family: '阿里巴巴普惠体 REGULAR';
        }
        .tip {
          position: absolute;
          bottom: 0;
          left: 14px;
          padding-left: 7px;
          width: 212px;
          height: 24px;
          border-radius: 20px;
          background: linear-gradient(
            90deg,
            #ffaa07 1.27%,
            rgba(255, 170, 7, 0) 100%
          );
          color: #fff;
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          font-family: '阿里巴巴普惠体 REGULAR';
          &:after {
            content: '→→';
            display: inline-block;
            width: 28px;
            height: 24px;
            line-height: 22px;
            // background: url('./../icon/arrow.png') no-repeat center center;
            // background-size: 28px 8px;
            vertical-align: top;
          }
          span {
            display: inline-block;
            line-height: 22px;
            height: 100%;
          }
        }
        .qrImg {
          position: absolute;
          width: 87px;
          height: 87px;
          bottom: 0;
          right: 14px;
          border-radius: 10px;
          background: #fff;
          .tips {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #b6b8bb;
            font-size: 14px;
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
        }
      }
    }
  }
}
</style>
